<style>

    .c-product-row {
        border-bottom: 1px solid #dddddd;
        padding: 20px;
    }

    .c-product-row img {
        width: 100%;
    }
    .c-product-row .product-discount-label, .c-product-grid .product-new-label {
        color: #fff;
        background-color: #16a085;
        font-size: 13px;
        font-weight: 800;
        text-transform: uppercase;
        line-height: 45px;
        height: 45px;
        width: 45px;
        border-radius: 50%;
        position: absolute;
        left: 10px;
        top: 15px;
        transition: all .3s
    }

    .c-product-row .product-discount-label {
        left: auto;
        right: 10px;
        background-color: #d7292a
    }

    .c-product-row:hover .product-new-label {
        opacity: 0
    }

    .c-product-row .product-content {
        padding: 25px
    }

    .c-product-row .price {
        font-size: 17px;
        font-weight: 700;
        margin: 0 2px 15px 0;
        display: block
    }

    .c-product-row .price span {
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 0;
        text-decoration: line-through;
        text-align: left;
        vertical-align: middle;
        display: inline-block
    }

</style>

<template>
    <b-row class="c-product-row">
        <b-col lg="2">
            <img :src="Core.Product.displayImage(dataProduct.image)">
        </b-col>
        <b-col lg="6">
            <h3 class="mb-4">{{dataProduct.title}}</h3>
            <p v-html="dataProduct.shortDescription"></p>
            <div v-if="dataProduct.variations !== undefined && dataProduct.variations.length > 0">
                <select class="mb-2" v-model="dataSelectedProduct">
                    <option :value="dataProduct.variations[variationIndex]" v-for="variation, variationIndex in dataProduct.variations">{{variation.title}}</option>
                </select>
            </div>
            <div class="price">
                {{Core.Currency.format(dataSelectedProduct.regularPrice)}}
            </div>
        </b-col>
        <b-col>
            <InputQuantity @onPlus="onPlus" @change="onChange" @onMinus="onMinus" v-model="dataSelectedProduct.quantity"></InputQuantity>
        </b-col>
        <b-col>
            <b-button-group size="sm">
                <b-button @click="$emit('onCartClick', dataSelectedProduct, dataProduct)"  class="btn btn-light"><b-badge class="animated fadeIn badge-success mr-2" v-if="cartCount !== false">{{cartCount}}</b-badge><i class="fa fa-shopping-cart"></i></b-button>
            </b-button-group>
        </b-col>
    </b-row>
</template>

<script>
    import InputQuantity from './InputQuantity'
    export default {
        name: 'ProductRow',
        components: {
            InputQuantity
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            }
        },
        watch: {
            value() {
                this.init()
            }
        },
        computed: {
            cartCount() {
                let productId = this.dataSelectedProduct.id
                let product = Core.Array.findByKey(Core.Session.Cart.products, 'id', productId)
                if (product !== false) {
                    return product.quantity
                }
                return false
            }
        },
        mounted() {
            this.init()
        },
        data: () => {
            return {
                Core: window.Core,
                dataProduct: {},
                dataSelectedProduct: {}
            }
        },
        methods: {
            init() {
                this.dataProduct = this.value
                if (this.dataProduct.variations !== undefined && this.dataProduct.variations.length > 0) {
                    this.dataSelectedProduct = this.dataProduct.variations[0]
                } else {
                    this.dataSelectedProduct = this.dataProduct
                }
                this.dataSelectedProduct.quantity = Core.Session.Cart.getQuantity(this.dataSelectedProduct.id)
            },
            onChange(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            },
            onPlus(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            },
            onMinus(quantity) {
                this.dataSelectedProduct.quantity = quantity
                this.$emit('onAddToCartClick', this.dataSelectedProduct)
            }
        }
    }
</script>